import {
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges,
    inject,
    ChangeDetectionStrategy
} from "@angular/core";
import { FormsModule } from "@angular/forms";
import { ButtonComponent } from "@components/button/button.component";
import { SelectorComponent } from "@components/selector/selector.component";
import moment from "moment";
import { SimpleSelectionItem } from "~app/common/components/selector/simple-selection-item";
import { ProduktionsomradeWithMODTO } from "~app/common/models/lagermal/LagermalBasDataDTO";
import { LagermalRequest } from "../../hantera-lagermal-models";
import { HanteraLagermalService } from "../../hantera-lagermal.service";

@Component({
    selector: "rask-hantera-lagermal-filter",
    templateUrl: "./hantera-lagermal-filter.component.html",
    styleUrls: ["./hantera-lagermal-filter.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        SelectorComponent,
        FormsModule,
        ButtonComponent
    ]
})
export class HanteraLagermalFilterComponent implements OnInit, OnChanges {
    allPOList: ProduktionsomradeWithMODTO[];
    internalResultRequest: LagermalRequest;
    moList: SimpleSelectionItem[];
    @Input() resultRequest: LagermalRequest;
    @Output() resultRequestChanged = new EventEmitter<LagermalRequest>();

    private readonly lagermalService = inject(HanteraLagermalService);

    canShow(): boolean {
        return (this.internalResultRequest.marknadsomradeId > 0 || this.internalResultRequest.produktionsomradeId > 1);
    }

    getPOList(): SimpleSelectionItem[] {
        if (!this.internalResultRequest.marknadsomradeId || this.internalResultRequest.marknadsomradeId <= 0) {
            return [];
        }
        return this.allPOList
            .filter(po => po.marknadsomradeId === this.internalResultRequest.marknadsomradeId)
            .map(po => ({ id: po.id,
                text: po.namn } as SimpleSelectionItem));
    }

    idFormatter = (ssi: SimpleSelectionItem) => ssi ? ssi.id : undefined;

    ngOnChanges(change: SimpleChanges) {
        if (change.resultRequest) {
            const lagermalReq = (change.resultRequest.currentValue as LagermalRequest);
            if (lagermalReq) {
                if (lagermalReq.produktionsomradeId) {
                    this.internalResultRequest.produktionsomradeId = lagermalReq.produktionsomradeId;
                }
                this.internalResultRequest.marknadsomradeId = lagermalReq.marknadsomradeId;
            }
        }
    }

    ngOnInit(): void {
        this.lagermalService.getLagermalBasData().subscribe(result => {
            this.moList = result.marknadsomraden.map(mo => ({ id: mo.id,
                text: mo.namn } as SimpleSelectionItem));
            this.allPOList = result.produktionsomraden;
        });
        if (!this.resultRequest) {
            this.resultRequest = new LagermalRequest();
        }
        this.internalResultRequest = this.resultRequest;
    }

    showResult() {
        if (!this.canShow()) {
            return;
        }
        const filter = new LagermalRequest();
        filter.marknadsomradeId = this.internalResultRequest.marknadsomradeId;
        filter.produktionsomradeId = this.internalResultRequest.produktionsomradeId;
        filter.monamn = this.moList.find(mo => mo.id === this.internalResultRequest.marknadsomradeId).text;
        if (this.internalResultRequest.produktionsomradeId) {
            filter.ponamn = this.allPOList.find(po => po.id === this.internalResultRequest.produktionsomradeId).namn;
        }
        filter.period = moment().toDate() as any;
        this.resultRequestChanged.emit(filter);
    }

    textFormatter = (ssi: SimpleSelectionItem) => ssi ? ssi.text : undefined;
}
